"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./jsdom");
require("mapbox-gl/dist/mapbox-gl.css");
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
const mapbox_gl_1 = __importDefault(require("mapbox-gl"));
const silica_1 = require("@opendoor/silica");
const ZipcodeList_1 = __importDefault(require("./ZipcodeList"));
const index_1 = require("@material-ui/core/index");
// @ts-ignore eslint-disable-next-line import/no-webpack-loader-syntax
mapbox_gl_1.default.workerClass = require('mapbox-gl/dist/mapbox-gl-csp-worker').default;
const ZOOM = 8;
const ZIPCODE_LAYER_ID = 'ZCTA5CE10';
const DEFAULT_LAT = 33.4484;
const DEFAULT_LON = -112.074;
const ZIPS_SOURCE_ID = 'zips';
const SOURCE_LAYER_ID = 'zipcode-51zag0';
const ALL_ZIPS_LAYER_ID = 'zip';
const ZIPS_HIGHLIGHTED_LAYER_ID = 'zips-highlighted';
const ZIPS_HIGHLIGHTED_BORDER_LAYER_ID = 'zips-highlighted-border';
const ZIPS_HOVERED_LAYER_ID = 'zips-hovered';
const ZIPS_OUTSIDE_LAYER_ID = 'zips-outside';
/**
 * Displays a map powered by Mapbox to show existing coverage and capture new areas.
 *
 */
const MapboxMap = ({ apiKey, markets, editable, saving, currentCoverage, defaultMarket, onSubmit, onCancel, }) => {
    var _a, _b, _c, _d, _e, _f;
    // this is where the map instance will be stored after initialization
    const [map, setMap] = react_1.default.useState();
    const [coverage, setCoverage] = react_1.useState(currentCoverage || { postalCodes: [] });
    const setZipCodes = (setZipCodeFn) => {
        // set trackedMarketIdentifier to undefined as changing zip codes
        // mean we don't track the market anymore
        setCoverage((prevCoverage) => ({
            postalCodes: setZipCodeFn(prevCoverage.postalCodes),
            trackedMarketIdentifier: undefined,
        }));
    };
    const zipCodes = coverage.postalCodes;
    const setTrackedMarket = (marketId) => {
        var _a, _b;
        if (marketId) {
            const marketPostalCodes = (_b = (_a = markets.find((m) => m.identifier === marketId)) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.postalCodes;
            if (marketPostalCodes) {
                setCoverage({ postalCodes: marketPostalCodes, trackedMarketIdentifier: marketId });
            }
        }
        else {
            setCoverage((prevCov) => ({
                postalCodes: prevCov.postalCodes,
                trackedMarketIdentifier: undefined,
            }));
        }
    };
    const [activeMarket, setActiveMarket] = react_1.useState(defaultMarket !== null && defaultMarket !== void 0 ? defaultMarket : markets[0]);
    const activeCoordinates = [
        (_c = (_b = (_a = activeMarket === null || activeMarket === void 0 ? void 0 : activeMarket.details) === null || _a === void 0 ? void 0 : _a.coordinates) === null || _b === void 0 ? void 0 : _b.long) !== null && _c !== void 0 ? _c : DEFAULT_LON,
        (_f = (_e = (_d = activeMarket === null || activeMarket === void 0 ? void 0 : activeMarket.details) === null || _d === void 0 ? void 0 : _d.coordinates) === null || _e === void 0 ? void 0 : _e.lat) !== null && _f !== void 0 ? _f : DEFAULT_LAT,
    ];
    const [showBuyBox, setShowBuyBox] = react_1.useState(false);
    // React ref to store a reference to the DOM node that will be used
    // as a required parameter `container` when initializing the mapbox-gl
    // will contain `null` by default
    const mapNode = react_1.default.useRef(null);
    const handleSubmit = () => {
        onSubmit(coverage);
    };
    if (!apiKey || apiKey.length === 0) {
        return react_1.default.createElement("div", null, "Please create mapbox application and pass API key");
    }
    //TODO: Extract effects into individual hooks
    react_1.default.useEffect(() => {
        const node = mapNode.current;
        // if the window object is not found, that means
        // the component is rendered on the server
        // or the dom node is not initialized, then return early
        if (typeof window === 'undefined' || node === null)
            return;
        // otherwise, create a map instance
        // Map style available: https://studio.mapbox.com/styles/opendoor/ckw9m90qjbiws15rzv114baog/edit/#6.39/47.259/-121.983
        const map = new mapbox_gl_1.default.Map({
            container: node,
            accessToken: apiKey,
            style: 'mapbox://styles/opendoor/ckw9m90qjbiws15rzv114baog',
            center: activeCoordinates,
            zoom: ZOOM,
        });
        // Add zoom and rotation controls to the map.
        map.addControl(new mapbox_gl_1.default.NavigationControl());
        // Zipcode boundary layer tiles available here: https://studio.mapbox.com/tilesets/opendoor.5cppecjc/\
        map.on('load', () => {
            var _a;
            map.addSource(ZIPS_SOURCE_ID, {
                type: 'vector',
                url: 'mapbox://opendoor.5cppecjc',
            });
            map.addLayer({
                id: ALL_ZIPS_LAYER_ID,
                type: 'fill',
                source: ZIPS_SOURCE_ID,
                layout: {
                    visibility: 'visible',
                },
                paint: {
                    'fill-outline-color': silica_1.colors.gray6,
                    'fill-color': 'rgba(0,0,0,0.1)',
                },
                'source-layer': SOURCE_LAYER_ID,
            }, 'water');
            map.addLayer({
                id: ZIPS_HIGHLIGHTED_LAYER_ID,
                type: 'fill',
                source: ZIPS_SOURCE_ID,
                'source-layer': SOURCE_LAYER_ID,
                paint: {
                    'fill-outline-color': silica_1.colors.blue6,
                    'fill-color': silica_1.colors.blue2,
                },
                filter: ['in', ZIPCODE_LAYER_ID, ''],
            }, 'water');
            map.addLayer({
                id: ZIPS_HIGHLIGHTED_BORDER_LAYER_ID,
                type: 'line',
                source: ZIPS_SOURCE_ID,
                'source-layer': SOURCE_LAYER_ID,
                paint: {
                    'line-width': 1.5,
                    'line-color': silica_1.colors.blue4,
                },
                filter: ['in', ZIPCODE_LAYER_ID, ''],
            }, 'water');
            map.addLayer({
                id: ZIPS_HOVERED_LAYER_ID,
                type: 'fill',
                source: ZIPS_SOURCE_ID,
                'source-layer': SOURCE_LAYER_ID,
                paint: {
                    'fill-outline-color': silica_1.colors.blue6,
                    'fill-color': silica_1.colors.blue1,
                },
                filter: ['in', ZIPCODE_LAYER_ID, ''],
            }, 'water');
            map.addLayer({
                id: ZIPS_OUTSIDE_LAYER_ID,
                type: 'fill',
                source: ZIPS_SOURCE_ID,
                layout: {
                    visibility: 'visible',
                },
                paint: {
                    'fill-outline-color': silica_1.colors.gray6,
                    'fill-color': 'rgba(0,0,0,0.4)',
                },
                'source-layer': SOURCE_LAYER_ID,
                filter: ['in', ZIPCODE_LAYER_ID, ''],
            }, 'water');
            refreshMap(map, zipCodes, showBuyBox ? (_a = activeMarket.details) === null || _a === void 0 ? void 0 : _a.buyBoxPostalCodes : undefined);
        });
        // save the map object to React.useState
        setMap(map);
        return () => {
            map.remove();
        };
    }, []);
    const refreshMap = (map, zipCodes, buyBoxZipCodes) => {
        map.setFilter(ZIPS_HIGHLIGHTED_BORDER_LAYER_ID, ['in', ZIPCODE_LAYER_ID, ...zipCodes]);
        map.setFilter(ZIPS_HIGHLIGHTED_LAYER_ID, ['in', ZIPCODE_LAYER_ID, ...zipCodes]);
        if (buyBoxZipCodes) {
            map.setFilter(ZIPS_OUTSIDE_LAYER_ID, ['!in', ZIPCODE_LAYER_ID, ...buyBoxZipCodes]);
        }
        else {
            map.setFilter(ZIPS_OUTSIDE_LAYER_ID, ['in', ZIPCODE_LAYER_ID, '']);
        }
    };
    react_1.default.useEffect(() => {
        var _a;
        if (map && map.isStyleLoaded()) {
            refreshMap(map, zipCodes, showBuyBox ? (_a = activeMarket.details) === null || _a === void 0 ? void 0 : _a.buyBoxPostalCodes : undefined);
        }
    }, [map, zipCodes, showBuyBox]);
    react_1.default.useEffect(() => {
        setShowBuyBox(false);
        if (map && map.isStyleLoaded()) {
            map.setCenter(activeCoordinates);
            refreshMap(map, zipCodes, undefined);
        }
    }, [map, activeMarket]);
    react_1.default.useEffect(() => {
        if (defaultMarket) {
            setActiveMarket(defaultMarket);
        }
    }, [defaultMarket]);
    react_1.default.useEffect(() => {
        if (currentCoverage) {
            setCoverage(currentCoverage);
        }
    }, [currentCoverage]);
    const trackedMarketIdentifier = coverage.trackedMarketIdentifier;
    react_1.default.useEffect(() => {
        if (map && editable && !trackedMarketIdentifier) {
            const onClick = (e) => {
                // Set `bbox` as 5px rectangle area around clicked point.
                const bbox = [
                    [e.point.x - 1, e.point.y - 1],
                    [e.point.x + 1, e.point.y + 1],
                ];
                // Find features intersecting the bounding box.
                const selectedFeatures = map.queryRenderedFeatures(bbox, {
                    layers: [ALL_ZIPS_LAYER_ID],
                });
                const zips = selectedFeatures.map((feature) => { var _a; return (_a = feature.properties) === null || _a === void 0 ? void 0 : _a[ZIPCODE_LAYER_ID]; });
                setZipCodes((prev) => {
                    const next = [...prev];
                    zips.forEach((zip) => {
                        if (next.includes(zip)) {
                            // Remove already selected zip codes that are clicked
                            next.splice(next.indexOf(zip), 1);
                        }
                        else {
                            // Add not selected zip codes that are clicked
                            next.push(zip);
                        }
                    });
                    return next;
                });
            };
            map.on('click', onClick);
            const onMouseMove = (e) => {
                const bbox = [
                    [e.point.x - 1, e.point.y - 1],
                    [e.point.x + 1, e.point.y + 1],
                ];
                // Find features intersecting the bounding box.
                const selectedFeatures = map.queryRenderedFeatures(bbox, {
                    layers: [ALL_ZIPS_LAYER_ID],
                });
                const zips = selectedFeatures.map((feature) => { var _a; return (_a = feature.properties) === null || _a === void 0 ? void 0 : _a[ZIPCODE_LAYER_ID]; });
                map.setFilter(ZIPS_HOVERED_LAYER_ID, ['in', ZIPCODE_LAYER_ID, ...zips]);
            };
            map.on('mousemove', ALL_ZIPS_LAYER_ID, onMouseMove);
            return () => {
                map.off('click', onClick);
                map.off('mousemove', ALL_ZIPS_LAYER_ID, onMouseMove);
            };
        }
    }, [map, editable, trackedMarketIdentifier]);
    return (react_1.default.createElement("div", { className: "flex flex-column h-100% w-100%" },
        react_1.default.createElement("div", { className: "flex justify-end pb-5" },
            react_1.default.createElement(Autocomplete_1.default, { className: "w-10 pr-2", options: markets, getOptionLabel: (option) => { var _a, _b; return (_b = (_a = option.details) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : ''; }, value: activeMarket, onChange: (event, value) => {
                    value && setActiveMarket(value);
                }, renderInput: (params) => (react_1.default.createElement(TextField_1.default, Object.assign({}, params, { size: "small", label: "View Market", color: "secondary" }))) }),
            react_1.default.createElement(index_1.FormControlLabel, { className: "pr-2 pl-4 pt-4", control: react_1.default.createElement(index_1.Checkbox, { checked: showBuyBox, size: "small", className: "ma-0 ph-1 pv-0", onChange: () => setShowBuyBox((prev) => !prev) }), label: react_1.default.createElement("span", { className: "fs-7" }, "Indicate areas outside Opendoor\u2019s buy box") })),
        react_1.default.createElement("div", { className: "flex", style: { flexGrow: 1, minHeight: '35vh' } },
            editable && (react_1.default.createElement("div", { className: "flex flex-column outline w-20% h-100%" },
                react_1.default.createElement(ZipcodeList_1.default, { markets: markets, activeMarket: activeMarket, selectedZipCodes: zipCodes, onZipCodeSelect: (selectedZipCodes) => setZipCodes((zips) => zips.concat(selectedZipCodes)), onZipCodeUnselect: (unselectedZipCodes) => setZipCodes((zips) => zips.filter((zipCode) => !unselectedZipCodes.includes(zipCode))), trackedMarketIdentifier: trackedMarketIdentifier, setTrackedMarketIdentifier: setTrackedMarket }))),
            react_1.default.createElement("div", { className: "outline flex", style: { flexGrow: 1 } },
                react_1.default.createElement("div", { ref: mapNode, className: "w-100% h-100%" }))),
        react_1.default.createElement("div", { className: "flex justify-end pt-5" }, editable && zipCodes.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Button_1.default, { color: "secondary", size: "small", variant: "outlined", onClick: onCancel }, "Close"),
            react_1.default.createElement(Button_1.default, { className: "ml-4 pl-4 pr-4", color: "primary", size: "small", variant: "contained", disabled: saving, onClick: handleSubmit }, saving ? react_1.default.createElement(CircularProgress_1.default, { size: 20 }) : 'Save'))))));
};
exports.default = MapboxMap;
